<label [class.checked]="checked"
       [class.container]="true"
       [title]="avatarTitle">
    <img (click)="input.click()" [src]="src">
    <input #input (change)="onChange($event)" [attr.aria-label]="avatarTitle" [checked]="checked" [name]="name"
           type="radio">
</label>
